<template>
  <main-layout>
    <div class="payDetail" v-if="isShow">
      <div class="payDetailBox clearfix" v-if="type == 1">
        <p class="detail criDetail">{{ $t("live.确认订单") }}</p>
        <div class="list">
          <p class="listDetail clearfix">
            <span class="title1">{{ $t("live.商品详情") }}</span
            ><span class="title2">{{ $t("live.价格") }}</span>
          </p>
          <div class="text clearfix">
            <div class="left clearfix">
              <img
                class="leftImg"
                :src="payDetail.horizontalThumb | imageUrl('https://image.manamana.net/1641283406000_WOWHgtGT', 320, 180)"
                alt=""
              />
              <div class="leftTitle">
                <p class="title1">
                  {{ payDetail.title }}
                </p>
                <p class="title2">{{ $t("live.直播") }}</p>
                <p class="title3">
                  {{ $t("live.开始时间") }}：{{
                    mydateFormat(payDetail.liveStartTime)
                  }}
                </p>
              </div>
            </div>
            <div class="right"><i>¥</i>{{ payDetail.price }}</div>
          </div>
          <div class="price">
            {{ $t("live.总计") }}：<span><i>¥</i>{{ payDetail.price }}</span>
          </div>
        </div>
        <p class="payType">{{ $t("live.支付方式") }}</p>
        <div class="pay">
          <span :class="{ active: payPlatform == 0 }" @click="payPlatform = 0"
            ><img src="/static/live/wechatpay_img@2x.png" alt="" /><i
              v-if="payPlatform == 0"
            ></i
          ></span>
          <span :class="{ active: payPlatform == 1 }" @click="payPlatform = 1"
            ><img src="/static/live/alipay_img@2x.png" alt="" /><i
              v-if="payPlatform == 1"
            ></i
          ></span>
        </div>
        <div class="payPrice">
          <p class="title1">
            {{ $t("live.待支付") }}：<span><i>¥</i>{{ payDetail.price }}</span>
          </p>
          <p class="title2">
            <span @click="gotoPay">{{ $t("live.立即支付") }}</span>
          </p>
          <p class="title3">
            {{ $t("live.提交订单即表示您已同意")
            }}<span @click="getRule">{{ $t("live.《吗呐平台商品交易服务协议》") }}</span>
          </p>
        </div>
      </div>
      <div class="payDetailBox clearfix" v-if="type == 2">
        <p class="detail">{{ $t("live.订单详情") }}</p>
        <p class="number" v-if="orderDetail.payStatus == 0">
          {{ $t("live.订单编号") }}：{{ orderDetail.orderNo }}，{{
            $t("live.请在")
          }}{{ rocallTime }}{{ $t("live.内完成支付") }}
        </p>
        <p class="number" v-else>
          {{ $t("live.订单编号") }}：{{ orderDetail.orderNo }}，{{
            payStatus(orderDetail.payStatus)
          }}
        </p>
        <div class="list">
          <p class="listDetail clearfix">
            <span class="title1">{{ $t("live.商品详情") }}</span
            ><span class="title2">{{ $t("live.价格") }}</span>
          </p>
          <div class="text clearfix">
            <div class="left clearfix">
              <img
                class="leftImg"
                :src="
                  orderDetail.liveResponse.horizontalThumb
                    | imageUrl('', 320, 180)
                "
                alt=""
              />
              <div class="leftTitle">
                <p class="title1">
                  {{ orderDetail.liveResponse.title }}
                </p>
                <p class="title2">{{ $t("live.直播") }}</p>
                <p class="title3">
                  {{ $t("live.开始时间") }}：{{
                    mydateFormat(orderDetail.liveResponse.liveStartTime)
                  }}
                </p>
              </div>
            </div>
            <div class="right"><i>¥</i>{{ orderDetail.livePrice }}</div>
          </div>
          <div class="price">
            {{ $t("live.总计") }}：<span><i>¥</i>{{ orderDetail.orderAmount }}</span>
          </div>
        </div>
        <div v-if="orderDetail.payStatus == 0">
          <p class="payType">{{ $t("live.支付方式") }}</p>
          <div class="pay">
            <span :class="{ active: payPlatform == 0 }" @click="payPlatform = 0"
              ><img src="/static/live/wechatpay_img@2x.png" alt="" /><i
                v-if="payPlatform == 0"
              ></i
            ></span>
            <span :class="{ active: payPlatform == 1 }" @click="payPlatform = 1"
              ><img src="/static/live/alipay_img@2x.png" alt="" /><i
                v-if="payPlatform == 1"
              ></i
            ></span>
          </div>
          <div class="payPrice">
            <p class="title1">
              {{ $t("live.待支付") }}：<span
                ><i>¥</i>{{ orderDetail.orderAmount }}</span
              >
            </p>
            <p class="title2">
              <span @click="createdPay">{{ $t("live.立即支付") }}</span>
            </p>
            <p class="title3">
              {{ $t("live.提交订单即表示您已同意")
              }}<span @click="getRule">{{ $t("live.《吗呐平台商品交易服务协议》") }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="payDetailBox clearfix" v-if="type == 3">
        <div v-if="orderNo">
          <p class="detail">{{ $t("live.订单详情") }}</p>
          <p class="number">
            {{ $t("live.订单编号") }}：{{ orderNo }}<span v-if="orderDetail.payPlatform != 2">，{{
              $t("live.请在")
            }}{{ rocallTime }}{{ $t("live.内完成支付") }}</span>
          </p>
        </div>
        <p v-else class="detail criDetail">{{ $t("live.确认订单") }}</p>
        <div class="list">
          <p class="listDetail clearfix">
            <span class="title1">{{ $t("live.商品详情") }}</span
            ><span class="title3">{{$t('recruit.数量')}}</span
            ><span class="title2">{{ $t("live.价格") }}</span>
          </p>
          <div class="text clearfix">
            <div class="left clearfix">
              <img
                class="leftImg"
                :src="mealDetail.type == 1 ?'https://image.manamana.net/1654584337000_quSFabIl':'https://image.manamana.net/1653466124000_WnHgTfiC'"
                alt=""
              />
              <div class="leftTitle">
                <p class="title1">
                  {{mealDetail.comboName}}
                </p>
                <p class="title2">{{$t('recruit.招聘')}}</p>
                <p class="title3">{{$t('recruit.有效期')}}：{{startTime + '-' + endTime}}</p>
              </div>
            </div>
            <div class="middle"><el-input-number v-model="num" size="mini" :disabled="orderNo?true:false" :min="1" :max="mealDetail.maxBuyCount"></el-input-number></div>
            <div class="right"><i>¥</i>{{mealDetail.price}}</div>
          </div>
          <div class="price">
            {{ $t("live.总计") }}：<span><i>¥</i>{{mealDetail.price*num}}</span>
          </div>
        </div>
        <div>
          <p class="payType">{{ $t("live.支付方式") }}</p>
          <div class="pay">
            <span :class="{ active: payPlatform == 0 }" @click="payPlatform = 0"
              ><img src="/static/live/wechatpay_img@2x.png" alt="" /><i
                v-if="payPlatform == 0"
              ></i
            ></span>
            <span :class="{ active: payPlatform == 1 }" @click="payPlatform = 1"
              ><img src="/static/live/alipay_img@2x.png" alt="" /><i
                v-if="payPlatform == 1"
              ></i
            ></span>
            <span :class="{ active: payPlatform == 2 }" @click="payPlatform = 2"
              ><img src="https://image.manamana.net/1653468180000_dxEirtiv" alt="" /><i
                v-if="payPlatform == 2"
              ></i
            ></span>
          </div>
          <div class="public" v-if="orderNo && payPlatform == 2">
            <p class="title">
              {{ $t("live.待支付") }}：<span
                ><i>¥</i>{{mealDetail.price*num}}</span
              >
            </p>
            <p class="title1">请向以下账户对公转账，我们将在确认贵司订单支付款项后的1个工作日内为您开通套餐</p>
            <div class="titleBox">
                <p>收款名称：上海吗呐网络科技有限公司</p>
                <p>收款账号：31050173460000000053</p>
                <p>开户行：中国建设银行股份有限公司上海长桥支行</p>
            </div>
          </div>
          <div class="payPrice" v-if="!(orderNo && payPlatform == 2)">
            <p class="title1">
              {{ $t("live.待支付") }}：<span
                ><i>¥</i>{{mealDetail.price*num}}</span
              >
            </p>
            <p class="title2">
              <span @click="createdPay1">{{ $t("live.立即支付") }}</span>
            </p>
            <p class="title3">
              {{ $t("live.提交订单即表示您已同意")
              }}<span @click="getRule">{{ $t("live.《吗呐平台商品交易服务协议》") }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-else v-html="htmlText"></div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
export default {
  metaInfo() {
    return {
      title: "MANA " + this.$t("live.订单详情")
    };
  },
  components: {
    MainLayout
  },
  data() {
    return {
      id: null,
      orderNo: null,
      type: null,
      payDetail: {},
      orderDetail: {},
      rocallTime: null,
      isShow: true,
      htmlText: null,
      payPlatform: 0,
      mealDetail: {},
      num: 1,
      startTime: null,
      endTime: null
    };
  },

  methods: {
    getRule() {
      this.$http
        .get("/api/common/page", {
          params: {
            id: 3339
          }
        })
        .then(res => {
          this.$alert(
            res.data.body,
            this.$t("live.《吗呐平台商品交易服务协议》"),
            {
              dangerouslyUseHTMLString: true,
              customClass: "alertMessage",
              showConfirmButton: false
            }
          );
        });
    },
    payStatus(status) {
      if (status == 0) {
        return this.$t("live.待支付");
      }
      if (status == 1) {
        return this.$t("live.已支付");
      }
      if (status == 2) {
        return this.$t("live.已退款");
      }
      if (status == 3) {
        return this.$t("live.已取消");
      }
    },
    gotoPay() {
      if (!localStorage.getItem("auth_token")) {
        this.$router.push(`/login?redirecturl=${window.location}`);
        return;
      }
      let params = {
        payPlatform: this.payPlatform,
        liveId: this.id
      };
      this.$http.get("/api/bytedance/" + this.id).then(response => {
        if (response.data.payStatus == 0) {
          if (this.payPlatform == 0) {
            this.$router.push(
              "/weChat/weChatPay?orderNo=" +
                response.data.orderNo +
                "&price=" +
                response.data.price
            );
          }
          if (this.payPlatform == 1) {
            this.$http
              .post(
                "/api/bytedance/order/pay?payType=" +
                  "ALIPAY_PC" +
                  "&orderNo=" +
                  response.data.orderNo,
                {
                  headers: {
                    "Content-Type": "application/json"
                  }
                }
              )
              .then(response => {
                const div = document.createElement("div");
                div.innerHTML = response.body; // html code
                document.body.appendChild(div);
                document.getElementById("bestPayForm").submit();
              });
          }
        } else {
          this.$http.post("/api/bytedance/order/create", params).then(res => {
            if (res.code == "OK") {
              if (this.payPlatform == 0) {
                this.$router.push(
                  "/weChat/weChatPay?orderNo=" +
                    res.data.orderNo +
                    "&price=" +
                    res.data.orderAmount
                );
              }
              if (this.payPlatform == 1) {
                this.$http
                  .post(
                    "/api/bytedance/order/pay?payType=" +
                      "ALIPAY_PC" +
                      "&orderNo=" +
                      res.data.orderNo,
                    {
                      headers: {
                        "Content-Type": "application/json"
                      }
                    }
                  )
                  .then(response => {
                    const div = document.createElement("div");
                    div.innerHTML = response.body; // html code
                    document.body.appendChild(div);
                    document.getElementById("bestPayForm").submit();
                  });
              }
            }
          });
        }
      });
    },
    createdPay() {
      if (!localStorage.getItem("auth_token")) {
        this.$router.push(`/login?redirecturl=${window.location}`);
        return;
      }
      this.$http.get("/api/bytedance/order/" + this.orderNo).then(res => {
        if (this.payPlatform == 0) {
          this.$router.push(
            "/weChat/weChatPay?orderNo=" +
              res.data.orderNo +
              "&price=" +
              res.data.livePrice
          );
        }
        if (this.payPlatform == 1) {
          this.$http
            .post(
              "/api/bytedance/order/pay?payType=" +
                "ALIPAY_PC" +
                "&orderNo=" +
                res.data.orderNo,
              {
                headers: {
                  "Content-Type": "application/json"
                }
              }
            )
            .then(response => {
              const div = document.createElement("div");
              div.innerHTML = response.body; // html code
              document.body.appendChild(div);
              document.getElementById("bestPayForm").submit();
            });
        }
      });
    },
    createdPay1() {
      if (!localStorage.getItem("auth_token")) {
        this.$router.push(`/login?redirecturl=${window.location}`);
        return;
      }
      let param = {
        payPlatform: this.payPlatform,
        liveId: this.id,
        quantity: this.num,
        payType:
          this.payPlatform == 0
            ? "WXPAY_NATIVE"
            : this.payPlatform == 1
              ? "ALIPAY_PC"
              : null
      };
      if (this.orderNo) {
        if (this.payPlatform == 0) {
          this.$router.push(
            "/weChat/weChatPay?orderNo=" +
              this.orderNo +
              "&price=" +
              this.mealDetail.price * this.num +
              "&type=1"
          );
        }
        if (this.payPlatform == 1) {
          this.$http
            .post(
              "/api/u/recruit/combo/pay?payType=" +
                "ALIPAY_PC" +
                "&orderNo=" +
                this.orderNo,
              {
                headers: {
                  "Content-Type": "application/json"
                }
              }
            )
            .then(response => {
              const div = document.createElement("div");
              div.innerHTML = response.body; // html code
              document.body.appendChild(div);
              document.getElementById("bestPayForm").submit();
            });
        }
        if (this.payPlatform == 2) {
          this.$router.push(
            "/meal/mealSuc?price=" + this.mealDetail.price * this.num
          );
        }
      } else {
        this.$http
          .post("/api/u/recruit/combo/buy", param, {
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(res => {
            if (this.payPlatform == 0) {
              this.$router.push(
                "/weChat/weChatPay?orderNo=" +
                  res.data.orderNo +
                  "&price=" +
                  res.data.orderAmount +
                  "&type=1"
              );
            }
            if (this.payPlatform == 1) {
              this.$http
                .post(
                  "/api/u/recruit/combo/pay?payType=" +
                    "ALIPAY_PC" +
                    "&orderNo=" +
                    res.data.orderNo,
                  {
                    headers: {
                      "Content-Type": "application/json"
                    }
                  }
                )
                .then(response => {
                  const div = document.createElement("div");
                  div.innerHTML = response.body; // html code
                  document.body.appendChild(div);
                  document.getElementById("bestPayForm").submit();
                });
            }
            if (this.payPlatform == 2) {
              this.$router.push(
                "/meal/mealSuc?price=" + this.mealDetail.price * this.num
              );
            }
          });
      }
    },
    getPayDetail() {
      this.$http.get("/api/bytedance/" + this.$query.id).then(res => {
        this.payDetail = res.data;
      });
    },
    getOrderDetail() {
      this.$http.get("/api/bytedance/order/" + this.orderNo).then(res => {
        this.orderDetail = res.data;
        this.payPlatform = res.data.payPlatform;
        this.ComputetTime(this.orderDetail.createTime);
      });
    },
    ComputetTime(data) {
      let st = new Date(), //当前服务器时间
        ct = data; //创建订单时间
      let ts = new Date(st).getTime(),
        tc = new Date(ct).getTime();
      let cm = 15 * 60 * 1000 - (ts - tc);
      this.runBack(cm);
    },
    runBack(cm) {
      var timer = null;
      if (cm > 0) {
        cm > 60000
          ? (this.rocallTime =
              (new Date(cm).getMinutes() < 10
                ? "0" + new Date(cm).getMinutes()
                : new Date(cm).getMinutes()) +
              ":" +
              (new Date(cm).getSeconds() < 10
                ? "0" + new Date(cm).getSeconds()
                : new Date(cm).getSeconds()))
          : (this.rocallTime =
              "00:" +
              (new Date(cm).getSeconds() < 10
                ? "0" + new Date(cm).getSeconds()
                : new Date(cm).getSeconds()));
        let _msThis = this;
        timer = setTimeout(function() {
          cm -= 1000;
          _msThis.runBack(cm);
        }, 1000);
      } else {
        this.rocallTime = "00:00";
        // this.getOrderDetail();//调用改变订单状态接口
      }
    },
    getMealDetail(id) {
      this.$http.get("/api/recruit/combo/" + id).then(res => {
        if (res.code == "OK") {
          this.mealDetail = res.data;
          let a = new Date();
          let year = a.getFullYear();
          let month = a.getMonth() + 1;
          let day = a.getDate();
          if (month < 10) {
            month = "0" + month;
          }
          if (day < 10) {
            day = "0" + day;
          }
          this.startTime = year + "." + month + "." + day;
          if (res.data.unit == 1) {
            this.endTime =
              Number(year) + res.data.indate + "." + month + "." + day;
          } else if (res.data.unit == 2) {
            if (Number(month) + res.data.indate > 12) {
              if (Number(month) + Number(res.data.indate) - 12 < 10) {
                this.endTime =
                  Number(year) +
                  1 +
                  "." +
                  "0" +
                  (Number(month) + res.data.indate - 12) +
                  "." +
                  day;
              } else {
                this.endTime =
                  Number(year) +
                  1 +
                  "." +
                  (Number(month) + res.data.indate - 12) +
                  "." +
                  day;
              }
            } else {
              if (Number(month) + Number(res.data.indate) < 10) {
                this.endTime =
                  year +
                  "." +
                  "0" +
                  (Number(month) + Number(res.data.indate)) +
                  "." +
                  day;
              } else {
                this.endTime =
                  year +
                  "." +
                  (Number(month) + Number(res.data.indate)) +
                  "." +
                  day;
              }
            }
          }
        }
      });
    }
  },

  created() {
    if (this.$query.type) {
      this.type = this.$query.type;
      if (this.$query.type == 3) {
        if (this.$query.id) {
          this.id = this.$query.id;
          this.getMealDetail(this.$query.id);
        }
        if (this.$query.quantity) {
          this.num = this.$query.quantity;
        }
        if (this.$query.orderNo) {
          this.orderNo = this.$query.orderNo;
          this.getOrderDetail();
        }
      } else {
        if (this.$query.id) {
          this.id = this.$query.id;
          this.getPayDetail();
        }
        if (this.$query.orderNo) {
          this.orderNo = this.$query.orderNo;
          this.getOrderDetail();
        }
      }
    }
  },
  mounted() {}
};
</script>
<style lang="stylus" scoped>
.payDetail {
  background: #ffffff;
  min-height: 70vh;

  .payDetailBox {
    width: 920px;
    margin: 0 auto;
    padding: 40px 0 80px;

    .detail {
      font-size: 24px;
      font-weight: 600;
      color: #0A0A0A;
      margin-bottom: 12px;
    }
    .criDetail {
      margin-bottom: 32px;
    }
    .number {
      margin-bottom: 32px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
    }

    .list {
      height: 220px;
      height: 220px;
      background: #FFFFFF;
      border: 1px solid #EBEBEB;
      position: relative;

      .listDetail {
        line-height: 40px;
        height: 40px;
        background: #F5F5F5;
        padding: 0 40px 0 30px;
        font-size: 0;

        .title1 {
          font-size: 14px;
          font-weight: 600;
          color: #999999;
          width: 550px;
          float: left;
        }

        .title2 {
          float: right;
          font-size: 14px;
          font-weight: 600;
          color: #999999;
          margin-right: 4px;
        }
        .title3{
          float: left;
          font-size: 14px;
          font-weight: 600;
          color: #999999;
          width: 130px;
          text-align: center;
        }
      }

      .text {
        padding: 0 40px 0 30px;
        margin-top: 24px;

        .left {
          float: left;

          .leftImg {
            width: 160px;
            height: 90px;
            float: left;
            margin-right: 20px;
          }

          .leftTitle {
            width: 550px;

            .title1 {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 16px;
              font-weight: 400;
              color: #0A0A0A;
              line-height: 22px;
            }

            .title2 {
              margin: 12px 0 13px 0;
              font-size: 14px;
              font-weight: 400;
              color: #666666;
            }

            .title3 {
              font-size: 14px;
              font-weight: 400;
              color: #666666;
            }
          }
        }

        .right {
          float: right;
          font-size: 16px;
          font-weight: 400;
          color: #0A0A0A;
        }
        .middle{
          float: left;
        }
      }

      .price {
        font-size: 16px;
        font-weight: 400;
        color: #0A0A0A;
        position: absolute;
        right: 40px;
        bottom: 23px;

        span {
          font-size: 18px;
          font-weight: 600;
          color: #0A0A0A;
          i{
            font-weight: 400;
          }
        }
      }
    }

    .payType {
      font-size: 18px;
      font-weight: 600;
      color: #333333;
      margin: 36px 0 16px 0;
    }

    .pay {
      font-size: 0;
      span {
        display: inline-block;
        width: 160px;
        height: 66px;
        background: #FFFFFF;
        border: 1px solid #E0E0E0;
        margin-right: 30px;
        position: relative;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }

        i {
          position: absolute;
          width: 24px;
          height: 24px;
          background: url('/static/live/icon_selected@2x.png') no-repeat;
          background-size: 100% 100%;
          bottom: 0;
          right: 0;
        }
      }

      .active {
        border: 1px solid #2026CC;
      }
    }
    .public{
      margin: 46px 0 57px 0;
      .title{
        font-size: 16px;
        font-weight: 400;
        color: #0A0A0A;
        line-height: 36px;

        span {
          vertical-align: middle;
          font-size: 24px;
          font-weight: 400;
          color: #FC6240;
          i{
            font-size: 24px;
            font-weight: 400;
            color: #FC6240;
          }
        }
      }
      .title1{
        height: 40px;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        margin-top: 40px;
      }
      .titleBox{
        height: 96px;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        line-height: 32px;
      }
    }
    .payPrice {
      float: right;
      margin-top: 8px;
      text-align: right;

      .title1 {
        font-size: 16px;
        font-weight: 400;
        color: #0A0A0A;
        line-height: 36px;

        span {
          vertical-align: middle;
          font-size: 24px;
          font-weight: 600;
          color: #FC6240;
          i{
            font-weight: 400;
          }
        }
      }

      .title2 {
        margin: 22px 0 20px 0;

        span {
          display: inline-block;
          width: 150px;
          height: 46px;
          line-height: 46px;
          background: #FC6240;
          font-size: 16px;
          font-weight: 600;
          color: #FFFFFF;
          text-align: center;
          cursor: pointer;
        }
      }

      .title3 {
        font-size: 14px;
        font-weight: 400;
        color: #666666;

        span {
          color: #2026CC;
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newLive/PayDetail.vue